import React, { useContext, useMemo } from "react";
import { SubscriptionsContext } from "./dashboard/store/SubscriptionsContext";
import { useAuthUser } from "./dashboard/hooks/useAuthUser";
import { userHasSubscriptionHistory } from "../utils/tierPricing";
import type { SubscriptionTier } from "../api/tiers";

type CsaTiersFormElementProps = {
  onTierSelected: (tierId: string) => void;
  selectedTier: string;
};
const CsaTiersFormElement = ({
  onTierSelected,
  selectedTier,
}: CsaTiersFormElementProps) => {
  const { subscriptions, tiers } = useContext(SubscriptionsContext);
  const { details } = useAuthUser();
  const hasHistory = userHasSubscriptionHistory(details?.subscriptionHistory);

  const subscriptionOptions = useMemo(() => {
    return subscriptions.map((sub) => {
      const subTiers: SubscriptionTier[] =
        sub.tiers && sub.tiers.length > 0
          ? sub.tiers
          : tiers.filter((tier) => tier.subscriptionId === sub.id);

      const tierList = subTiers.map((tier) => {
        const isAvailable = tier.isAvailable ?? false;

        const className = isAvailable
          ? selectedTier === tier.id
            ? "info-card info-card-clickable csa-price-box csa-selected"
            : "info-card info-card-clickable csa-price-box"
          : "info-card csa-price-box csa-unavailable";

        return (
          <div
            key={tier.id}
            role={isAvailable ? "button" : undefined}
            tabIndex={isAvailable ? 0 : undefined}
            aria-disabled={!isAvailable}
            onClick={
              isAvailable ? () => onTierSelected(tier.id) : undefined
            }
            onKeyDown={
              isAvailable
                ? (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      onTierSelected(tier.id);
                    }
                  }
                : undefined
            }
            className={className}
          >
            <h4 className="csa-tier-name-row">
              {tier.name}
              {!isAvailable && (
                <span className="sales-tag">No spots available</span>
              )}
            </h4>
            <p>
              <span className={hasHistory ? "bold text-crossed-out" : "bold"}>
                {tier.price}:-
              </span>
            </p>
            <p className="gray-text">
              Returning member price: {tier.oldCsaMemberPrice}:-
            </p>
          </div>
        );
      });
      return (
        <div key={sub.id} className="info-card csa-subscription-box">
          <h3>{sub.name}</h3>
          <div className="csa-page-list-of-tiers">{tierList}</div>
        </div>
      );
    });
  }, [subscriptions, tiers, selectedTier, onTierSelected, hasHistory]);

  return <>{subscriptionOptions}</>;
};

export default CsaTiersFormElement;
